var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import classnames from "classnames";
import React, { Component } from "react";
import styles from "./statics/styles/in-plugin-input.scss";
class InPluginInput extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "handleFocus", (e) => {
      e.stopPropagation();
      this.props.setFocusToBlock();
      this.props.setInPluginEditingMode(true);
    });
    __publicField(this, "handleBlur", () => this.props.setInPluginEditingMode(false));
    __publicField(this, "handleKeyPress", (e) => {
      const { setFocusToBlock, value } = this.props;
      if (e.key === "Enter" && setFocusToBlock && value !== "") {
        this.handleBlur();
        setFocusToBlock();
      }
    });
    __publicField(this, "onChange", (e) => {
      var _a, _b;
      return (_b = (_a = this.props).onChange) == null ? void 0 : _b.call(_a, e.target.value);
    });
  }
  render() {
    const className = classnames(styles.inPluginInput, this.props.className);
    return /* @__PURE__ */ React.createElement(
      "textarea",
      {
        className,
        value: this.props.value,
        onChange: this.onChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: this.handleKeyPress,
        dir: "auto",
        rows: 1
      }
    );
  }
}
__publicField(InPluginInput, "defaultProps", {
  setInPluginEditingMode: () => false,
  setFocusToBlock: () => false
});
var InPluginInput_default = InPluginInput;
export {
  InPluginInput_default as default
};
//# sourceMappingURL=InPluginInput.js.map
